<template>
  <f7-page>
    <navbar title="Hoppsan" back-link="Tillbaka"></navbar>
    <f7-block strong>
      <p>Sidan hittades inte.</p>
    </f7-block>
  </f7-page>
</template>
<script>
  export default {};
</script>